import React from 'react';
import { Link } from 'react-router-dom';

/**
 * 404 page. Rendered inside Layout so the nav and footer stay available —
 * a dead end with working internal links is far better for both users and
 * crawlers than bouncing every unknown URL to the home page.
 *
 * nginx returns a real HTTP 404 for these URLs (see nginx.conf) and the route
 * is marked noindex in src/seoConfig.js.
 */
const NotFound = () => (
  <section className="op-section">
    <div className="op-container">
      <div className="op-section-head">
        <span className="op-kicker">404</span>
        <h1>We couldn&rsquo;t find that page</h1>
        <p>
          The link may be out of date, or the address may have been typed slightly differently.
          Everything below is one click away.
        </p>
      </div>

      <div className="op-grid-3">
        <div className="op-card">
          <div className="op-card-icon">🏠</div>
          <h3>Home</h3>
          <p>What OmniPrac does for an anaesthetic practice.</p>
          <Link to="/">Go to the home page</Link>
        </div>
        <div className="op-card">
          <div className="op-card-icon">💬</div>
          <h3>Pricing</h3>
          <p>How OmniPrac is quoted, and how to request a proposal.</p>
          <Link to="/pricing">See pricing</Link>
        </div>
        <div className="op-card">
          <div className="op-card-icon">🔐</div>
          <h3>Client login</h3>
          <p>Already a customer? Sign in with your practice name.</p>
          <Link to="/login">Client login</Link>
        </div>
      </div>
    </div>
  </section>
);

export default NotFound;
